import { connect } from 'react-redux';
import { IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { openPanel } from '../../trackingConsent';
import { NavbarIconButton } from '../../../components';

interface AllowChatButtonProps {
    handleClick(): void;
}

const AllowChatButton: React.FC<AllowChatButtonProps> = ({ handleClick }) => (
    <NavbarIconButton
        icon={IconName.HelpCenter}
        title={<LocalizedText textKey={TextKey.EnableFunctionalCookiesForHelpCenterAndChat} />}
        onClick={handleClick}
        warning
    />
);

export default connect(undefined, {
    handleClick: openPanel,
})(AllowChatButton);
